import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AssetManagementService } from '../../../../services/asset-management.service';
import { LocalDataSource } from 'ng2-smart-table';

@Component({
  selector: 'filter-data',
  templateUrl: './filter-data.component.html',
  styleUrls: ['./filter-data.component.scss']
})
export class FilterDataComponent implements OnInit {
  filterData: boolean;
  updateData: boolean;
  isChecked = false;
  assetIds: any;
  customerData: any;

  constructor(public dialogRef: MatDialogRef<FilterDataComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private assetManagementService: AssetManagementService,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.filterData = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  dataUpdate(): void {
    this.updateData = true;
    this.filterData = false;
    this.assetManagementService.setAssetId(this.assetIds);
  }

  onBack() {
    this.updateData = false;
    this.filterData = true;
    this.isChecked = false;
  }

  onRowSelect(event) {
    this.isChecked = event.selected.length > 0 ? true : false;
    this.assetIds = event.selected.map(x => x.assetId);
  }

  settings = {
    selectMode: 'multi',
    actions: false,
    pager: {
      display: true,
      perPage: 5
    },
    columns: {
      locationName: {
        title: 'Location'
      },
      serialNumber: {
        title: 'Serial Number'
      },
      vin: {
        title: 'Vin'
      },
      year: {
        title: 'Year'
      },
      make: {
        title: 'Make'
      },
      model: {
        title: 'Model'
      },
      color: {
        title: 'Color'
      },
      inServiceDate: {
        title: 'Service Date'
      },
      inActiveSoldDate: {
        title: 'Active Sold Date'
      },
      transmissionManufacture: {
        title: 'Transmission Manufacture'
      },
      frontAxleManufacture: {
        title: 'Front Axle Manufacture'
      },
      driveType: {
        title: 'Drive Type'
      },
      license_Exp_Date: {
        title: 'License Exp Date'
      },
      unladenWeight: {
        title: 'Unladen Weight'
      },
      leaseCompanyId: {
        title: 'Leasing Company'
      },
      assetDescription: {
        title: 'Asset Description'
      },
      engineModel: {
        title: 'Engine Model'
      },
      transmissionModel: {
        title: 'Transmission Model'
      },
      refrigManufacturer: {
        title: 'Referring Manufacturer'
      },
      refrigModel: {
        title: 'Referring Model'
      },
      tireSize: {
        title: 'Tire Size'
      },
      suspension: {
        title: 'Suspension'
      },
      license: {
        title: 'License'
      },
      licenseState: {
        title: 'License State'
      },
      hotAlert: {
        title: 'Hot Alert'
      },
      equipmentVocation: {
        title: 'Equipment Vocation'
      },
      equipmentCategory: {
        title: 'Equipment Category'
      },
      axleConfiguration: {
        title: 'Axle Configuration'
      },
      cabType: {
        title: 'Cab Type'
      },
      powerSource: {
        title: 'Power Source'
      },
      transmissionType: {
        title: 'Transmission Type'
      },
      trailerLength: {
        title: 'Trailer Length'
      },
      vehicleStatusCode: {
        title: 'Vehicle Status Code'
      },
      powerTakeOff: {
        title: 'Power Take Off'
      },
      oilType: {
        title: 'Oil Type'
      },
      assetClass: {
        title: 'Asset Class'
      },
      lifeCycleExpiration: {
        title: 'Life Cycle Expiration'
      },
      calculationMethod: {
        title: 'Calculation Method'
      },
      lastValidatedMileage: {
        title: 'Last Validated Mileage'
      },
      currentAssumedMileage: {
        title: 'Current Assumed Mileage'
      },
      lastValidatedHours: {
        title: 'Last Validated Hours'
      },
      currentAssumedHours: {
        title: 'Current Assumed Hours'
      },
      assetTypeGroup1: {
        title: 'Asset Type Group'
      },
      severityOfService1: {
        title: 'Severity Of Service'
      },
      bodyStyleConfiguration1: {
        title: 'Body Style Configuration'
      },
      engineManufacturer1: {
        title: 'Engine Manufacturer'
      },
      lastMileageUpdateDate: {
        title: 'Last Mileage Update Date'
      },
      lastHoursUpdateDate: {
        title: 'Last Hours Update Date'
      },
      isManaged: {
        title: 'Is Managed'
      },
      managedStartDate: {
        title: 'Managed Start Date'
      },
      managedEndDate: {
        title: 'Managed End Date'
      },
      updateDetails: {
        title: 'Update Details'
      },
      dOTNumber: {
        title: 'DOT Number'
      },
      inputFileStatus: {
        title: 'Input File Status'
      },
      engineSize: {
        title: 'Engine Size'
      },
      dateAdded: {
        title: 'Date Added'
      },
      externalPurchaseGroupName: {
        title: 'Purchase Group Name'
      },
      detailedDescription: {
        title: 'Detailed Description'
      },
      currentAssumedMilesUpdatedDate: {
        title: 'Current Assumed Miles Updated Date'
      },
      currentAssumedHoursUpdatedDate: {
        title: 'Current Assumed Hours Updated Date'
      },
      stateInspection: {
        title: 'State Inspection'
      },
      eRS_ID: {
        title: 'ERS ID'
      },
      meterReadingSource: {
        title: 'Meter Reading Source'
      },
      assetDateUpdated: {
        title: 'Asset Date Updated'
      },
      avgHrsPerMonth: {
        title: 'Avg Hrs Per Month'
      },
      avgMilesPerMonth: {
        title: 'Avg Miles Per Month'
      },
      vINDecoded: {
        title: 'VIN Decoded'
      }
    }
  };

  records: LocalDataSource = new LocalDataSource();
}

